import Plyr from 'plyr';
import { getTranslation } from '../Utils';

// Global variable to ensure cleanup of old instances
let $lightbox: HTMLDivElement | null = null;

function closeLightbox(e: MouseEvent) {
    if (e.target != e.currentTarget) {
        return;
    }

    $lightbox?.remove();
    $lightbox = null;
}

function onKeyUp(e: KeyboardEvent) {
    if ($lightbox == null) {
        return;
    }

    if (e.key === 'Escape') {
        e.preventDefault();
        $lightbox?.remove();
    }
}

function createLightbox(youTubeID: string) {
    // Remove old lightbox (if cleanup failed)
    $lightbox?.remove();

    $lightbox = document.createElement('div');
    $lightbox.className = 'fixed inset-0 flex items-center justify-center bg-black/80'; // using classname for tailwind

    const $lightboxInner = document.createElement('div');
    $lightboxInner.className = 'relative h-auto w-[90vw] lg:h-[70vh] lg:w-[70vw]';

    // on click outside player or escape, exit player.
    $lightbox.addEventListener('click', closeLightbox);

    // Create plyr element, add to lightboxInner
    const $player = document.createElement('div');
    $player.className = 'plyr__video-embed';

    const $playerInner = document.createElement('iframe');
    $playerInner.src = `https://www.youtube-nocookie.com/embed/${youTubeID}`;
    $playerInner.allowFullscreen = true;
    $playerInner.setAttribute('allowtransparency', '');
    $playerInner.allow = 'autoplay';
    $playerInner.className = 'relative h-auto w-[90vw] lg:h-[70vh] lg:w-[70vw]';

    $player.appendChild($playerInner);
    $lightboxInner.appendChild($player);

    // Cannot use Plyr.setup as it is for multiple instances!
    new Plyr($player, {
        controls: [
            'play-large', // The large play button in the center
            'play', // Play/pause playback
            'progress', // The progress bar and scrubber for playback and buffering
            'mute', // Toggle mute
            'volume', // Volume control
            'fullscreen', // Toggle fullscreen
        ],
    });

    // create close button, add to lightboxInner
    const $closeButton = document.createElement('button');
    $closeButton.textContent = getTranslation('lightboxutil.closePlayer');
    $closeButton.className = 'absolute top-4 right-4 text-white bg-black bg-opacity-50 px-4 py-2 rounded-md';
    $closeButton.addEventListener('click', closeLightbox);
    $lightboxInner.appendChild($closeButton);

    $lightbox.appendChild($lightboxInner);
    document.body.appendChild($lightbox);
}

/* * Helper function for toggling hidden class */
export function registerPlyrLightBox(): void {
    // try find all elements with data-* tag for youtube id
    const $videoRoots = document.querySelectorAll('[data-plyr-lightbox]');

    if (!$videoRoots?.length)
        return;

    document.addEventListener('keyup', onKeyUp);

    $videoRoots.forEach($videoRoot => {
        const youTubeID = $videoRoot.getAttribute('data-plyr-lightbox');

        // Check if value is set (is neither null or empty)
        if (!youTubeID?.length) {
            return;
        }

        // on click => fixed lightbox with a plyr player with YouTube.
        $videoRoot.addEventListener('click', () => {
            createLightbox(youTubeID);
        });
    });
}
